import { render, staticRenderFns } from "./Display.vue?vue&type=template&id=724e5946&scoped=true&"
import script from "./Display.vue?vue&type=script&lang=js&"
export * from "./Display.vue?vue&type=script&lang=js&"
import style0 from "./Display.vue?vue&type=style&index=0&id=724e5946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e5946",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724e5946')) {
      api.createRecord('724e5946', component.options)
    } else {
      api.reload('724e5946', component.options)
    }
    module.hot.accept("./Display.vue?vue&type=template&id=724e5946&scoped=true&", function () {
      api.rerender('724e5946', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/contractors/Display.vue"
export default component.exports